module.exports = __webpack_public_path__ + "img/design.e4fb7153.png";